import {
  BCard,
  BBadge,
  BLink,
  BFormGroup,
  BFormInvalidFeedback,
  BFormTextarea,
  BAlert,
  BEmbed,
  BSkeleton
} from 'bootstrap-vue'

export default function registerBootstrapVueComponents(app) {
  app.component('BBadge', BBadge)
  app.component('BCard', BCard)
  app.component('BLink', BLink)
  app.component('BFormGroup', BFormGroup)
  app.component('BFormInvalidFeedback', BFormInvalidFeedback)
  app.component('BFormTextarea', BFormTextarea)
  app.component('BAlert', BAlert)
  app.component('BEmbed', BEmbed)
  app.component('BSkeleton', BSkeleton)
}
